module.exports = __webpack_public_path__ + "static/media/rectangle-large-header.61c7315f.png";